import {Component, Vue} from "vue-property-decorator"

// noinspection JSUnusedGlobalSymbols - Required by Vue to be "export default"
@Component
export default class ToolbarSearchWidget extends Vue {

  public static readonly EventExpand = "expand"
  public static readonly EventCollapse = "collapse"
  public static readonly EventQueryUpdated = "query-updated"

  private query: string = ""

  private static get searchText(): HTMLInputElement {
    return document.querySelector("#toolbarSearchText") as HTMLInputElement
  }

  private static get searchButton(): HTMLButtonElement {
    return (document.querySelector("#toolbarSearchButton") as HTMLButtonElement)
  }

  private static get closeButton(): HTMLButtonElement {
    return (document.querySelector("#toolbarSearchClose") as HTMLButtonElement)
  }

  // noinspection JSUnusedLocalSymbols - used in Vue template
  private onSearchClicked(): void {
    ToolbarSearchWidget.searchText.style.display = "flex"
    ToolbarSearchWidget.closeButton.style.display = "flex"
    ToolbarSearchWidget.searchButton.style.display = "none"
    ToolbarSearchWidget.searchText.focus()
    this.$emit(ToolbarSearchWidget.EventExpand)
  }

  // noinspection JSUnusedLocalSymbols - used in Vue template
  private onCloseClicked(): void {
    ToolbarSearchWidget.searchText.style.display = "none"
    ToolbarSearchWidget.closeButton.style.display = "none"
    ToolbarSearchWidget.searchButton.style.display = "unset"
    this.query = ""
    this.$emit(ToolbarSearchWidget.EventCollapse)
  }

  // noinspection JSUnusedLocalSymbols - used in Vue template
  private onQueryUpdate(): void {
    this.$emit(ToolbarSearchWidget.EventQueryUpdated, this.query)
  }
}
